
const produtovendaGridConfig = [
  { header: "Venda", field: "idVenda" },
  { header: "Produto", field: "produto" },
  { header: "Quantidade", field: "quantidade" }
];

export default produtovendaGridConfig;